export default "__VITE_ASSET__DhRnNrKX__"